import React from 'react';
import { DevicesDataProvider } from '../../../data/DataProviders/DevicesDataProvider';
import { DeviceGroups } from '../../../components/DeviceGroups';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { LocationsDropdownToolbar } from '../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { useSingleLocationRedirect, useSelectedOrganizationData, isRecordFound } from '../../../hooks/data-hooks';
import { ContentContainer } from '../../../components/ContentContainer';
import { RecordDataIndicators } from '../../../components/RecordDataIndicators';

export const DevicesOrganization: React.FC = () => {
    const selectedOrganizationData = useSelectedOrganizationData();
    const { t } = useLanguageLocale();
    useSingleLocationRedirect();

    return (
        <>
            <LocationsDropdownToolbar title={t('DASHBOARD.DEVICES_TITLE')} />

            <ContentContainer testId="organization-devices">
                <RecordDataIndicators
                    recordData={selectedOrganizationData}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                    notFoundIcon="Business"
                    notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
                />

                {isRecordFound(selectedOrganizationData) && (
                    <DevicesDataProvider organizationId={selectedOrganizationData.value.id}>
                        <DeviceGroups
                            deviceDetailAppRoute={{
                                type: 'DevicesOrganizationDeviceDetails',
                                deviceId: '--',
                            }}
                        />
                    </DevicesDataProvider>
                )}
            </ContentContainer>
        </>
    );
};
